export const RETURN_PAGE_STEP_KEY = 'returnPageStep';
export const PROHIBITIONS_KEY = 'prohibitions';
